import * as React from 'react';
import useGetAppointmentPayments from '../../hooks/appointments/useGetAppointmentPayments';
import TransactionsList from '../transactions/TransactionsList';
import { convertPaymentsToTransactions } from '../../helpers/payments';
import { Appointment } from '../../interfaces';
import useCashDiscount from '../../hooks/payments/useCashDiscount';

export default function TransactionsSection({
  appointment,
  useSpecStyle,
}: {
  appointment: Appointment;
  useSpecStyle?: boolean;
}) {
  const { payments, isFetching } = useGetAppointmentPayments(appointment);
  const { cashDiscountEnabled: businessCashDiscountEnabled } =
    useCashDiscount();

  const cleanedPayments = React.useMemo(
    () =>
      convertPaymentsToTransactions(payments, {
        appointment,
        businessCashDiscountEnabled,
      }),
    [payments, appointment, businessCashDiscountEnabled],
  );

  return (
    <TransactionsList
      transactions={cleanedPayments}
      isLoading={isFetching}
      useSpecStyle={useSpecStyle}
    />
  );
}
